export default "# FileLink 文件链接\r\n\r\n用于预览、下载、批量下载文件。\r\n\r\n提供统一的文件链接操作。\r\n\r\n## 何时使用\r\n\r\n- ...。";